/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { DialogActions, Icon, IconButton } from '@mui/material';
import { get } from 'global/lib/lodash';
import { useScreen } from '../../styles';
import { Button } from '../Button';
import { ModalProvider } from './ModalContext';
import {
  BarTitle,
  CloseButton,
  ContentWrap,
  FullScreenAppBar,
  FullScreenDialog,
  FullScreenDialogTitle,
  FullScreenToolbar,
  ModalContent,
  StandardDialog,
  StandardDialogContent,
  StandardDialogTitle,
  TitleFull,
} from './styles';

export const FullScreen = (props) => {
  const handleClose = () => {
    props.onClose();
  };

  return (
    <FullScreenDialog
      data-testid="perform-dialog"
      fullScreen
      disableEscapeKeyDown
      open={props.open}
      onClose={() => handleClose()}
    >
      <FullScreenDialogTitle>
        <FullScreenAppBar color="secondary">
          <FullScreenToolbar>
            <IconButton edge="start" color="inherit" onClick={() => handleClose()} aria-label="Close" size="large">
              <Icon>{get(props, 'closeIcon', 'close')}</Icon>
            </IconButton>

            {props.renderTitle ? (
              props.renderTitle()
            ) : (
              <BarTitle>
                <TitleFull variant="h5">
                  {typeof props.title === 'function' ? props.title() : props.title}
                </TitleFull>
              </BarTitle>
            )}

            {!!props.endIcon && (
              <Icon onClick={props.endIconClick} style={{ marginLeft: 'auto', cursor: props.endIconClick ? 'pointer' : 'defautl' }}>
                {props.endIcon}
              </Icon>
            )}
            {!!props.renderEndIcon && props.renderEndIcon(props)}
          </FullScreenToolbar>
        </FullScreenAppBar>
      </FullScreenDialogTitle>

      <ContentWrap style={props.centerContentStyle} className={props.centerContent}>
        <ModalProvider>{props.children}</ModalProvider>
      </ContentWrap>

      {!!props.buttons && (
        <DialogActions {...(props.dialogActions || {})}>
          {(props.buttons || []).map((btn, i) => {
            return (
              <Button key={i} color="secondary" {...btn}>
                {get(btn, 'title', 'Done')}
              </Button>
            );
          })}
        </DialogActions>
      )}
    </FullScreenDialog>
  );
};

export default (props) => {
  const { isMobile } = useScreen();

  const Comp = props.content || props.children;
  const fullHeight = get(props, 'fullHeight', false);

  return (
    <StandardDialog
      keepMounted={props.keepMounted}
      classes={props.classes || {}}
      maxWidth={props.maxWidth || undefined}
      fullWidth={props.fullWidth || undefined}
      fullScreen={isMobile || props.fullScreen}
      className={props.className}
      open={!!props.open}
      onClose={() => props.onClose()}
      isMobile={isMobile}
      fullHeight={fullHeight}
      paperMaxWidth={props.paperMaxWidth}
    >
      <StandardDialogTitle>{props.title}</StandardDialogTitle>

      <StandardDialogContent>
        {Comp && !props.children && (
          <ModalContent isMobile={isMobile} style={{ minWidth: isMobile ? '100%' : props.minWidth || 500 }}>
            <ModalProvider>{typeof props.content === 'function' ? <Comp /> : props.content}</ModalProvider>
          </ModalContent>
        )}

        {props.children && (
          <ModalContent isMobile={isMobile} style={{ minWidth: isMobile ? '100%' : props.minWidth || 500 }}>
            <ModalProvider>{props.children}</ModalProvider>
          </ModalContent>
        )}
      </StandardDialogContent>

      <CloseButton onClick={() => props.onClose()} size="large" aria-label="close">
        <Icon>close</Icon>
      </CloseButton>

      <DialogActions {...(props.dialogActions || {})}>
        {(props.buttons || []).map((btn, i) => {
          return (
            <Button key={i} color="secondary" {...btn}>
              {get(btn, 'title', 'Done')}
            </Button>
          );
        })}
      </DialogActions>
    </StandardDialog>
  );
};
